export default __webpack_public_path__ + "static/media/video1.bb8304f1.webp";